import { forwardRef, useContext, useImperativeHandle, useRef } from "react";
import styled from "styled-components";
import WalletTile from "../WalletTile";
import { Context } from "../../context/WalletContext"
import CloseIcon from "../../assets/svg/CloseIcon";
import ChangeWalletModal from "./ChangeWalletModal";

const StyledWalletManagerModal = styled.dialog`
    width: 695px;
    height: 555px;
    background: #1C1C1C;
    border-radius: 32px;
    display: none;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;     
    padding: 24px;
    border-width: 0px;
    
    &::backdrop {        
        background-color: #00000090;
    }

    &[open]{
        display: flex;
    }
    
    #title{
        font-family: Exo 2;
        font-weight: 400;
        font-size: 30px;
        line-height: 100%;
        letter-spacing: 0%;
        color: #FFFFFF;
    }

    #subtitle{
        font-family: Exo 2;
        font-weight: 300;
        font-size: 20px;
        line-height: 100%;
        letter-spacing: 0%;
        color: #A6A6A6;
    }

    /* Hide scrollbar for Chrome, Safari and Opera */
    #wallet-list::-webkit-scrollbar {
      display: none;
    }

    /* Hide scrollbar for IE, Edge and Firefox */
    #wallet-list {
      -ms-overflow-style: none;  /* IE and Edge */
      scrollbar-width: none;  /* Firefox */
    }

    #wallet-list{
        width: 100%;
        height: 320px !important;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: center; 
        margin-top: 20px;
        margin-bottom: 20px;
        gap: 50px;
        overflow-y: scroll;
        padding: 0px 0px 20px 0px;
    }

    #add-wallet{
        width: 100%;
        height: 50px;
        border-radius: 14px;
        padding: 16px;
        background: linear-gradient(#38EF7D, #11998E);
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        cursor: pointer;
    }

    #modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin: 0px 0px 16px 0px;
    }

    #close-button{
      cursor: pointer;
    }
`;

const WalletManagerModal = forwardRef(function WalletManagerModal({}, ref) {
  const modalRef = useRef();
  const warningModalRef = useRef();
  const walletContext = useContext(Context);

  useImperativeHandle(ref, () => {
    return {
      open: open,
      close: close,
    };
  });

  function open() {
    modalRef.current.showModal();
  }

  function close() {
    modalRef.current.close();
  }

  return (<StyledWalletManagerModal ref={modalRef}>
    <ChangeWalletModal ref={warningModalRef} title={'Something went wrong'} description={"We couldn't add your wallet, it might be linked to another account or already added to this account"}></ChangeWalletModal>
    <div id="modal-header">
      <p id="title">Manage Wallets</p>
      <div id="close-button" onClick={close}>
        <CloseIcon height={36} width={36}></CloseIcon>
      </div>
    </div>
    <p id="subtitle">Add one or more wallets to showcase all your Items in one place.</p>
    <div id="wallet-list">
      {
        walletContext.state?.userWallet?.wallets?.metamask.map((wallet) =>
          <WalletTile
            key={wallet}
            isMintingWallet={wallet === walletContext?.state?.userWallet?.mintingWallet}
            isQorbiWallet={wallet === walletContext?.state?.userWallet?.qorbiWallet}
            address={wallet}
            isMetamask={true}
          >
          </WalletTile>)

      }
      {
        walletContext?.state?.userWallet?.wallets?.passport_address &&
        <WalletTile
          isMintingWallet={walletContext?.state?.userWallet?.wallets.passport_address === walletContext?.state?.userWallet?.mintingWallet}
          isQorbiWallet={walletContext?.state?.userWallet?.wallets.passport_address === walletContext?.state?.userWallet?.qorbiWallet}
          address={walletContext?.state?.userWallet?.wallets?.passport_address}
          isMetamask={false}
        >
        </WalletTile>
      }
    </div>
  </StyledWalletManagerModal>);
});

export default WalletManagerModal;